import { Alarm, AlarmMachine } from '../gql/generated';

/** The label for a machine EDMS cannot name, the same wherever it appears. */
export const UNKNOWN_MACHINE_LABEL = 'Unknown machine';

/**
 * The name a machine reads as, wherever an alert names it. A machine EDMS no
 * longer lists comes back without a name; its ids are never shown.
 */
export function machineDisplayName(machine: AlarmMachine): string {
  return machine.displayName || UNKNOWN_MACHINE_LABEL;
}

/** The machines the alerts cover, each one named once. */
export function uniqueMachineNames(alarms: Alarm[]): string[] {
  return [
    ...new Map(
      alarms
        .flatMap((alarm) => alarm.machines || [])
        .map((machine) => [
          machine.machineId || machine.id,
          machineDisplayName(machine),
        ])
    ).values(),
  ];
}
